// removed by extract-text-webpack-plugin
module.exports = {"snackbar":"theme__snackbar___zDi3X","accept":"theme__accept___2Y0Cy","button":"theme__button___2pCxU","warning":"theme__warning___2li3o","cancel":"theme__cancel___3731C","active":"theme__active___38CsO","label":"theme__label___1JIbY"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/snackbar/theme.css
// module id = 1452
// module chunks = 0